import { useSession } from "@how/app-kit";
import { useQuery } from "@tanstack/react-query";
import type { Enums } from "@how/database";
import { supabase } from "../../lib/supabase";

export type PlatformRole = Enums<"platform_role">;

/** The caller's active platform role, read from platform_memberships (self-read policy). null = not DCX staff. */
export function usePlatformRole() {
  const session = useSession();
  const userId = session.status === "signed_in" ? session.session.user.id : null;
  return useQuery({
    queryKey: ["platform-role", userId],
    enabled: userId !== null,
    queryFn: async (): Promise<PlatformRole | null> => {
      const { data, error } = await supabase
        .from("platform_memberships")
        .select("role, status")
        .eq("user_id", userId ?? "")
        .maybeSingle();
      if (error) throw error;
      return data !== null && data.status === "active" ? data.role : null;
    },
  });
}
